import { Select, type SelectProps } from "../core/Select/Select";
import { useFieldConnection, type ConnectedFieldProps } from "./useFieldConnection";

export interface SelectFieldProps
  extends Omit<SelectProps, "name">,
    ConnectedFieldProps {}

/**
 * Un `Select` ya cableado al formulario que lo envuelve. Mismo trato que
 * `TextField`: la pantalla deja de pasar `register`, `error` y `disabled`,
 * y todo lo demás viaja tal cual, así que la accesibilidad sigue siendo la
 * que `Select` ya resolvía.
 */
export function SelectField({
  name,
  registerOptions,
  disabled,
  error,
  ...rest
}: SelectFieldProps) {
  const field = useFieldConnection(name, registerOptions);

  return (
    <Select
      {...rest}
      disabled={disabled ?? field.disabled}
      error={error ?? field.error}
      {...field.registration}
    />
  );
}
